import { Database } from "@moe/priv/types/sb-types";
import { createClient } from "@supabase/supabase-js";
import { config } from "@web/lib/config";

// @ts-ignore
export const sb = createClient<Database>(config.supabaseURL, config.supabaseAnonKey);
